import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { GSTHeadCells, inventoryDropDown, Outstandingdata, tdstcsdata } from '../newReports/data';

const ReportContext = createContext();

export const useReportContext = () => {
  const context = useContext(ReportContext);
  if (!context) {
    throw new Error('useReportContext must be used within ReportContextProvider');
  }
  return context;
};

export const ReportContextProvider = ({ children }) => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);

  const { id: reportId } = useParams();
  console.log(reportId, 'reportIdreportId');

  useEffect(() => {
    if (reportId === '5') {
      setReportData({
        allAccounts: tdstcsdata,
      });
    } else if (reportId === '6') {
      setReportData({
        allAccounts: GSTHeadCells,
      });
    } else if (reportId === '7') {
      setReportData({
        allAccounts: Outstandingdata,
      });
    } else if (reportId === '9') {
      setReportData({
        allAccounts: inventoryDropDown,
      });
    }
  }, [reportId]);

  const updateReportData = useCallback((data) => {
    setReportData(data);
  }, []);

  return <ReportContext.Provider value={{ reportData, updateReportData, loading, setLoading }}>{children}</ReportContext.Provider>;
};
